import { useEffect, useState } from 'react';

export const isZeroAmount = (value: string | null | undefined): boolean => {
  if (value == null) return false;
  const normalized = value.replace(/\./g, '').replace(',', '.');
  return (parseFloat(normalized) || 0) === 0;
};

export const computeSaldo = (
  saldo: number | null | undefined,
  debito: number | null | undefined,
  credito: number | null | undefined,
): number | null => {
  if (saldo != null) return saldo;
  if (debito == null && credito == null) return null;
  return (debito ?? 0) - (credito ?? 0);
};

export const formatSaldo = (value: number): string =>
  value.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const useAutoExpand = (hasData: boolean) => {
  const [isExpanded, setIsExpanded] = useState(hasData);
  useEffect(() => {
    setIsExpanded(hasData);
  }, [hasData]);
  return [isExpanded, setIsExpanded] as const;
};

export const padRows = <T>(rows: T[], maxRows: number, emptyFactory: () => T): T[] => [
  ...rows,
  ...Array.from({ length: Math.max(0, maxRows - rows.length) }, emptyFactory),
];

/**
 * Props for a validated input in the F24 review forms: highlights the field and
 * shows `message` only when `hasError` is set. Spread onto a TextField/AmountField
 * (`{...requiredFieldProps(errors?.codiceTributo, tValidations('required'))}`) so
 * the isInvalid/errorMessage wiring lives in one place instead of being repeated
 * per input.
 */
export const requiredFieldProps = (
  hasError: boolean | undefined,
  message: string,
): { isInvalid: boolean; errorMessage: string | undefined } => ({
  isInvalid: !!hasError,
  errorMessage: hasError ? message : undefined,
});
